module.exports = __webpack_public_path__ + "static/slac.7446b9d9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/slac.gif
// module id = 2223
// module chunks = 61762850755587